import { gql } from 'graphql-request'

export const adjustPackageExpiryMutation = gql`
  mutation AdjustPackageExpiry($serviceId: String!, $expiresAtDate: String!, $siteId: String!) {
    adjustPackageExpiry(serviceId: $serviceId, expiresAtDate: $expiresAtDate, siteId: $siteId)
  }
`

export const adjustServiceCreditsMutation = gql`
  mutation AdjustServiceCredits($input: AdjustCreditsInput!) {
    adjustServiceCredits(input: $input)
  }
`

export const suspendServiceMutation = gql`
  mutation SuspendService(
    $serviceId: String!
    $startDate: String
    $endDate: String
    $reason: String
    $chargeMode: ServiceSuspensionChargeMode
    $chargeAmount: Numeric
    $bookingIds: [String!]
    $failedInvoiceIds: [String!]
    $siteId: String!
  ) {
    suspendService(
      serviceId: $serviceId
      startDate: $startDate
      endDate: $endDate
      reason: $reason
      chargeMode: $chargeMode
      chargeAmount: $chargeAmount
      bookingIds: $bookingIds
      failedInvoiceIds: $failedInvoiceIds
      siteId: $siteId
    )
  }
`

export const resumeServiceMutation = gql`
  mutation ResumeService($serviceId: String!, $notes: String, $siteId: String!) {
    resumeService(serviceId: $serviceId, notes: $notes, siteId: $siteId)
  }
`

export const cancelServiceMutation = gql`
  mutation CancelService(
    $serviceId: String!
    $reason: String
    $cancelAt: String
    $bookingIds: [String!]
    $failedInvoiceIds: [String!]
    $siteId: String!
  ) {
    cancelService(
      serviceId: $serviceId
      reason: $reason
      cancelAt: $cancelAt
      bookingIds: $bookingIds
      failedInvoiceIds: $failedInvoiceIds
      siteId: $siteId
    )
  }
`

export const restoreServiceMutation = gql`
  mutation RestoreService($serviceId: String!, $notes: String, $siteId: String!) {
    restoreService(serviceId: $serviceId, notes: $notes, siteId: $siteId)
  }
`

export const cancelScheduledSuspensionMutation = gql`
  mutation CancelScheduledSuspension(
    $serviceSuspensionId: String!
    $reason: String
    $siteId: String!
  ) {
    cancelScheduledSuspension(
      serviceSuspensionId: $serviceSuspensionId
      reason: $reason
      siteId: $siteId
    )
  }
`

export const cancelScheduledCancellationMutation = gql`
  mutation CancelScheduledCancellation($serviceCancellationId: String!, $reason: String) {
    cancelScheduledCancellation(serviceCancellationId: $serviceCancellationId, reason: $reason)
  }
`

export const changeMembershipPlanMutation = gql`
  mutation ChangeMembershipPlan($input: ChangeMembershipPlanInput!) {
    changeMembershipPlan(input: $input) {
      servicePlanChangeId
    }
  }
`

export const cancelScheduledPlanChangeMutation = gql`
  mutation CancelScheduledPlanChange($input: CancelScheduledPlanChangeInput!) {
    cancelScheduledPlanChange(input: $input)
  }
`
